function ClearFilterButton({handleClearFilters}){
return ( 
    <> 
    <div className="d-flex justify-content-around">
    <button onClick={() => handleClearFilters()} className="el-text-btn">Clear filter</button>
    </div>
    </>
);
}

export default ClearFilterButton;